import { createResponsesImage } from '../createResponsesImage/createResponsesImage';
import component from './ResponsesImage503Svg';

export const ResponsesImage503 = createResponsesImage({
  name: 'ResponsesImage503',
  component,
});
